import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ValorationPageRoutingModule } from './valoration-routing.module';

import { ValorationPage } from './valoration.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ValorationPageRoutingModule
  ],
  declarations: [ValorationPage]
})
export class ValorationPageModule {}
